import React, { useState, useEffect } from 'react';
import Form from '../../np-form/Form';
import { withStyles, Grid, Select, MenuItem, FormControl, FormHelperText } from '@material-ui/core';
import * as formUtility from '../../np-form/utility';
import makeAnimated from 'react-select/animated';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'

const animatedComponents = makeAnimated();

const breakpoints = createBreakpoints({})
// outputs {xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920}

breakpoints.values.xl = 1400
// outputs {xs: 0, sm: 600, md: 960, lg: 1024, xl: 1920}
const styles = theme => ({
    form: {
        margin: theme.spacing(2),
        width: "90%",
        marginTop: -15,
    },
    date: {
        marginBottom: '-55px', marginTop: '35px', marginLeft: 'unset',
        [theme.breakpoints.down('md')]: {

            marginBottom: '-55px', marginTop: '38px', marginLeft: 'unset'
        },
        [theme.breakpoints.down('sm')]: {
            marginBottom: '-55px', marginTop: '38px', marginLeft: 'unset'

        },

    },

});
const updateFormStateOne = (classes, translations) => {
    const memoryOption = [{ label: translations['customer_name'] || 'Customer name', value: 'CustomerName' }, { label: translations["username"] || 'Username', value: 'UserName' }, { label: translations["storage_type"] || 'Storage type', value: 'StorageType' }, { label: translations["order_name"] || 'Order name', value: 'Order' }, { label: translations["transport_colli_name"] || 'Transport colli name', value: 'TransportColliName' }]

    const form = {
        Memory: {
            elementType: 'multi-select',
            elementConfig: {
                type: 'multi-select',
                isMulti: true,
                closeMenuOnSelect: false,
                components: animatedComponents,
                className: classes.inputs,
                name: 'users',
                label: translations['group_by'] || 'Group by',
                options: memoryOption,
                selected: ['UserName'],
                margin: "dense",
                fullWidth: true,
                isDisabled: true
            },
            formHelperText: translations['group_by'] || 'Group by:',
            value: ['UserName'],
            validation: {
                required: true
            },
            valid: true,
            touched: true
        },

    };
    return form;
}

const ReportTableFilter = props => {
    const { classes, onGetColumns, date, setDate, translations } = props;
    const [filterForm, setFilterForm] = useState(updateFormStateOne(classes, translations));

    useEffect(() => {
        setFilterForm(updateFormStateOne(classes, translations));
    }, [classes, translations]);

    const formInputChangedHandler = (event, inputIdentifier) => {
        const updateState = formUtility.getNewStateOnInputChange(event, inputIdentifier, filterForm);
        setFilterForm(updateState.myForm);
    };
    const onMultiSelectChange = (ids, data, identifier) => {
        const updatedState = formUtility.getNewStateOnMultiSelectChange(ids, identifier, filterForm);
        setFilterForm(updatedState.myForm);
    };
    const [values, setValues] = React.useState('day');

    const handleChange = async (event) => {
        setValues(event.target.value);
        setDate({ ...date, type: event.target.value });
        await onGetColumns({ ...date, type: event.target.value });
    }

    return (
        <Grid
            container
        >
            <Grid
                item
                lg={9}
                sm={6}
                xl={9}
                xs={12}
            >
                <Form
                    formIsValid={true}
                    form={filterForm}
                    getMultiSelectData={onMultiSelectChange}
                    inputChangedHandler={formInputChangedHandler}

                />
            </Grid>
            <Grid
                item
                lg={3}
                sm={6}
                xl={3}
                xs={12}
            >
                <FormControl
                    variant="filled"
                    className={classes.form}
                >
                    <FormHelperText className={classes.date}>{translations['period_grouping'] || "Period grouping:"}</FormHelperText>
                    <Select
                        value={values}
                        onChange={handleChange}
                        style={{ marginTop: '55px', width: '100%', height: '38px' }}>
                        <MenuItem value={'day'}>{translations['day'] || "day"}</MenuItem>
                        <MenuItem value={'week'}>{translations['week'] || "week"}</MenuItem>
                        <MenuItem value={'month'}>{translations['month'] || "month"}</MenuItem>
                        <MenuItem value={'year'}>{translations['year'] || "year"}</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default withStyles(styles, { withTheme: true })(ReportTableFilter);